import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const useGetItemsVersion = (
  section1ListId?: string,
  itemNoVersionId?: string,
) =>
  $journalApi.useQuery(
    "get",
    "/api/v1/journals/section-one/{section1ListId}/items/{itemNoVersionId}/versions",
    {
      params: {
        path: {
          section1ListId: section1ListId!,
          itemNoVersionId: itemNoVersionId!,
        },
      },
      enabled: !!section1ListId && !!itemNoVersionId,
    },
    {
      staleTime: 0,
      refetchOnMount: "always",
    },
  );

